<template>
    <div>
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker
                            :label="$t('datetime.finalDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                            <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            v-model="busca"
                            :label="porUnidade
                                ? $t('optimizedRoutesHistory.filters.unit')
                                : $t('optimizedRoutesHistory.filters.line')"
                            clearable
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            v-model="sentidoFiltro"
                            :items="sentidosItems"
                            :label="$t('optimizedRoutesHistory.filters.direction')"
                            clearable
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            v-model="origemFiltro"
                            :items="origensItems"
                            :label="$t('optimizedRoutesHistory.filters.origin')"
                            clearable
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="populaRelatorio"
                                    style="margin-bottom: 5px;"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-chip
                    v-if="filtroId != null"
                    close
                    small
                    color="primary"
                    outlined
                    class="mb-2"
                    @click:close="limpaFiltroId"
                >
                    {{ filtroIdLabel }}
                </v-chip>
            </v-form>
        </v-container>

        <MerusDataTable
            :key="codTabela"
            :headers="tableHeaders"
            :items="itemsFiltered"
            :loading="loading"
            :default-multi-sort="defaultSort"
            :loading-text="$t('optimizedRoutesHistory.loading')"
            :cod-tabela="codTabela"
            @update:headers="headers = $event"
        >
            <template v-slot:toolbar>
                <CadastroToolbar
                    :title="$t('optimizedRoutesHistory.title')"
                    :token="token"
                    :items="itemsFiltered"
                    :csv-title="csvTitle"
                    :pdf-title="$t('optimizedRoutesHistory.title')"
                    :pdf-headers="tableHeaders"
                    :pdf-filename="csvTitle"
                    hide-search
                />
            </template>
            <template v-slot:item.dt_arquivamento_extenso="{ item }">
                <v-chip v-if="item.atual" x-small color="primary">{{ $t('optimizedRoutesHistory.current') }}</v-chip>
                <template v-else>{{ item.dt_arquivamento_extenso }}</template>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip x-small :color="statusColor(item.status)" text-color="white">{{ statusLabel(item.status) }}</v-chip>
            </template>
            <template v-slot:item.distancia_km="{ item }">
                {{ formatNumber(item.distancia_km, 1) }}
            </template>
            <template v-slot:item.duracao_min="{ item }">
                {{ formatNumber(item.duracao_min, 0) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon small color="primary" @click="openDetail(item)">
                    <v-icon small>mdi-compare</v-icon>
                </v-btn>
            </template>
        </MerusDataTable>

        <v-dialog v-model="detailShow" max-width="1200" scrollable>
            <v-card v-if="detailShow">
                <v-card-title>
                    {{ detailTitle }}
                    <v-spacer />
                    <v-btn icon @click="detailShow = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear v-if="detailLoading" indeterminate class="mb-4" />
                    <v-row v-else>
                        <v-col cols="12" md="8">
                            <v-row class="mb-2" dense>
                                <v-col cols="12" sm="6">
                                    <v-card outlined class="pa-3">
                                        <div class="text-subtitle-1 font-weight-bold mb-1">
                                            {{ $t('optimizedRoutesHistory.selectedVersion') }}
                                        </div>
                                        <div v-for="info in resumoSelecionada" :key="info.label" class="body-2">
                                            {{ info.label }}: <strong>{{ info.valor }}</strong>
                                            <span v-if="info.delta" :class="deltaClass(info.deltaNum)">({{ info.delta }})</span>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-card outlined class="pa-3">
                                        <div class="text-subtitle-1 font-weight-bold mb-1">
                                            {{ $t('optimizedRoutesHistory.previousVersion') }}
                                        </div>
                                        <div v-if="!versaoAnteriorRow" class="body-2 text--secondary">
                                            {{ $t('optimizedRoutesHistory.noPrevious') }}
                                        </div>
                                        <template v-else>
                                            <div v-for="info in resumoAnterior" :key="info.label" class="body-2">
                                                {{ info.label }}: <strong>{{ info.valor }}</strong>
                                            </div>
                                        </template>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-alert
                                v-if="selecionadaRow && selecionadaRow.mensagem"
                                type="warning"
                                dense
                                outlined
                                class="mb-2"
                            >
                                {{ selecionadaRow.mensagem }}
                            </v-alert>

                            <v-row dense align="center" class="mb-1">
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="mostraSelecionada"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="rho-swatch" :style="{ background: corSelecionada }" />
                                            {{ $t('optimizedRoutesHistory.mapSelected') }}
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="mostraAnterior"
                                        :disabled="!versaoAnteriorRow"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    >
                                        <template #label>
                                            <span class="rho-swatch rho-swatch--dashed" :style="{ borderColor: corAnterior }" />
                                            {{ $t('optimizedRoutesHistory.mapPrevious') }}
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="mostraParadas"
                                        :label="$t('optimizedRoutesHistory.mapStops')"
                                        hide-details
                                        dense
                                        class="mt-0"
                                    />
                                </v-col>
                            </v-row>
                            <v-progress-linear v-if="versaoLoading" indeterminate class="mb-1" />
                            <v-alert v-if="!temGeometria && !versaoLoading" type="info" dense outlined>
                                {{ $t('optimizedRoutesHistory.mapEmpty') }}
                            </v-alert>
                            <div v-show="temGeometria" class="rho-map">
                                <l-map
                                    ref="detailMap"
                                    :key="mapKey"
                                    :zoom="12"
                                    :center="defaultCenter"
                                    style="height: 100%; width: 100%; border-radius: 8px;"
                                    @ready="ajustaMapa"
                                >
                                    <l-tile-layer :url="tileUrl" :attribution="attribution" />
                                    <template v-if="mostraAnterior">
                                        <template v-for="c in camadasAnterior">
                                            <l-geo-json :key="`ant-fundo-${c.key}`" :geojson="c.geojson" :options="c.fundo" />
                                            <l-geo-json :key="`ant-fluxo-${c.key}`" :geojson="c.geojson" :options="c.fluxo" />
                                            <l-marker
                                                v-for="(seta, si) in c.setas"
                                                :key="`ant-seta-${c.key}-${si}`"
                                                :lat-lng="[seta.lat, seta.lng]"
                                                :icon="seta.icon"
                                                :z-index-offset="6"
                                            />
                                        </template>
                                    </template>
                                    <template v-if="mostraSelecionada">
                                        <template v-for="c in camadasSelecionada">
                                            <l-geo-json :key="`sel-fundo-${c.key}`" :geojson="c.geojson" :options="c.fundo" />
                                            <l-geo-json :key="`sel-fluxo-${c.key}`" :geojson="c.geojson" :options="c.fluxo" />
                                            <l-marker
                                                v-for="(seta, si) in c.setas"
                                                :key="`sel-seta-${c.key}-${si}`"
                                                :lat-lng="[seta.lat, seta.lng]"
                                                :icon="seta.icon"
                                                :z-index-offset="7"
                                            />
                                        </template>
                                    </template>
                                    <template v-if="mostraParadas">
                                        <l-circle-marker
                                            v-for="p in paradasSelecionada"
                                            :key="`par-${p.key}`"
                                            :lat-lng="[p.lat, p.lng]"
                                            :radius="6"
                                            :color="p.cor"
                                            :fill-color="p.cor"
                                            :fill-opacity="0.9"
                                            :weight="1"
                                        >
                                            <l-tooltip>{{ p.label }}</l-tooltip>
                                        </l-circle-marker>
                                    </template>
                                </l-map>
                            </div>
                            <div v-if="porUnidade && rotasSelecionada.length" class="mt-2">
                                <div class="text-subtitle-2 mb-1">{{ $t('optimizedRoutesHistory.routes') }}</div>
                                <v-chip
                                    v-for="r in rotasSelecionada"
                                    :key="r.key"
                                    small
                                    outlined
                                    class="mr-1 mb-1"
                                >
                                    <span class="rho-swatch" :style="{ background: r.cor }" />
                                    {{ r.label }}
                                </v-chip>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="text-subtitle-2 mb-1">{{ $t('optimizedRoutesHistory.timeline') }}</div>
                            <div class="text-caption mb-2 grey--text">
                                {{ $t('optimizedRoutesHistory.timelineHint') }}
                            </div>
                            <v-timeline dense clipped class="rho-timeline">
                                <v-timeline-item
                                    v-for="(row, i) in versoes"
                                    :key="chaveVersao(row)"
                                    :color="statusColor(row.status)"
                                    small
                                >
                                    <div
                                        class="rho-timeline-item"
                                        :class="{ 'rho-timeline-item--active': i === indiceSelecionada }"
                                        role="button"
                                        tabindex="0"
                                        @click="selecionaVersao(i)"
                                        @keydown.enter.prevent="selecionaVersao(i)"
                                    >
                                        <div class="font-weight-medium">
                                            {{ row.dt_geracao_extenso }}
                                            <v-chip v-if="row.atual" x-small color="primary" class="ml-1">
                                                {{ $t('optimizedRoutesHistory.current') }}
                                            </v-chip>
                                        </div>
                                        <div class="text-caption">
                                            {{ statusLabel(row.status) }}
                                            · {{ origemLabel(row) }}
                                            <template v-if="row.nome_usuario"> ({{ row.nome_usuario }})</template>
                                        </div>
                                        <div class="text-caption">{{ resumoTimeline(row) }}</div>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import L from 'leaflet';
import { LMap, LTileLayer, LGeoJson, LCircleMarker, LMarker, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import DateUtils from '@/utils/dateutils';
import {
    FLUXO_ORIGINAL,
    FLUXO_SELECIONADA,
    buildDirectionMarkers,
    buildRouteLayerOptions,
    estiloFluxoOriginal,
    estiloFluxoSelecionada,
    estiloFundoRota,
    iconDirecaoRota,
} from '@/utils/mapaFluxoRota';
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

/** Mesmas cores das abas Comparação: otimizada em roxo; a versão anterior em vermelho tracejado. */
const COR_SELECIONADA = '#8E24AA';
const COR_ANTERIOR = '#C62828';
const COR_NAO_ATENDIDA = '#D50000';
/** Uma cor por rota da consolidação da unidade. */
const CORES_ROTAS = ['#8E24AA', '#1565C0', '#2E7D32', '#EF6C00', '#00838F', '#6D4C41', '#AD1457', '#283593', '#9E9D24', '#4E342E'];

function toNumber(v) {
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}

export default {
    name: 'HistoricoRotasOtimizadasPainel',
    components: { MerusDataTable, CadastroToolbar, LMap, LTileLayer, LGeoJson, LCircleMarker, LMarker, LTooltip },
    props: {
        /** Aba Unidades da tela Histórico de rotas; senão, aba Linhas. */
        porUnidade: { type: Boolean, default: false },
    },
    data: () => ({
        headers: [],
        token: null,
        formValidado: false,
        items: [],
        loading: false,
        dti: null,
        dtf: null,
        busca: null,
        sentidoFiltro: null,
        origemFiltro: null,
        /** id_linha/id_unidade vindo do botão "Histórico" das abas Comparação (filtro no servidor). */
        filtroId: null,
        filtroSentido: null,
        timeProps: { useSeconds: true },
        detailShow: false,
        detailLoading: false,
        detailItem: null,
        versoes: [],
        indiceSelecionada: 0,
        versaoSelecionada: null,
        versaoAnterior: null,
        versaoLoading: false,
        versaoSeq: 0,
        mostraSelecionada: true,
        mostraAnterior: true,
        mostraParadas: true,
        mapKey: 0,
        tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        corSelecionada: COR_SELECIONADA,
        corAnterior: COR_ANTERIOR,
    }),
    computed: {
        codTabela() {
            return this.porUnidade ? 'RELHISTORICOROTAS_UNIDADES' : 'RELHISTORICOROTAS_LINHAS';
        },
        csvTitle() {
            return this.porUnidade ? 'historicorotasotimizadasunidades' : 'historicorotasotimizadaslinhas';
        },
        defaultCenter() {
            const c = this.$store && this.$store.getters ? this.$store.getters['config/centerDefault'] : null;
            if (!c || !Array.isArray(c) || c.length < 2) return [-22.88746, -43.29185];
            return [Number(c[0]), Number(c[1])];
        },
        defaultSort() {
            return [{ value: 'dt_geracao', options: { text: this.$t('routs.decreasing'), value: -1 } }];
        },
        defaultHeaders() {
            const col = (value, align, filtrable = true) => ({
                text: this.$t(`optimizedRoutesHistory.headers.${value}`),
                value,
                align: align || null,
                sortable: true,
                filtrable,
                show: true,
            });
            const especificas = this.porUnidade
                ? [
                    col('descricao_unidade'),
                    col('descricao_sentido'),
                    col('status'),
                    col('qtd_linhas_atuais', 'end', false),
                    col('qtd_rotas', 'end', false),
                    col('qtd_paradas', 'end', false),
                    col('distancia_km', 'end', false),
                    col('duracao_min', 'end', false),
                    col('qtd_nao_atendidas', 'end', false),
                ]
                : [
                    col('cod_linha'),
                    col('descricao_sentido'),
                    col('status'),
                    col('distancia_km', 'end', false),
                    col('duracao_min', 'end', false),
                    col('qtd_paradas', 'end', false),
                    col('qtd_nao_atendidas', 'end', false),
                ];
            return [
                col('dt_geracao_extenso'),
                col('dt_arquivamento_extenso'),
                ...especificas,
                col('origem_extenso'),
                col('nome_usuario'),
                {
                    text: this.$t('optimizedRoutesHistory.headers.actions'),
                    value: 'actions',
                    sortable: false,
                    filtrable: false,
                    show: true,
                },
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        textFieldProps() {
            return { prependInnerIcon: 'mdi-calendar' };
        },
        dtiProps() {
            return { max: new Date().toISOString().substring(0, 10) };
        },
        dtfProps() {
            const d = this.dti instanceof Date ? this.dti : null;
            return { min: d ? d.toISOString().substring(0, 10) : null };
        },
        sentidosItems() {
            const vistos = new Set(this.items.map((i) => i.descricao_sentido).filter(Boolean));
            return Array.from(vistos).sort();
        },
        origensItems() {
            return [
                { text: this.$t('optimizedRoutesHistory.origin.manual'), value: 'manual' },
                { text: this.$t('optimizedRoutesHistory.origin.automatic'), value: 'automatica' },
            ];
        },
        itemsFiltered() {
            const busca = this.busca ? String(this.busca).trim().toLowerCase() : '';
            return this.items.filter((i) => {
                if (this.sentidoFiltro && i.descricao_sentido !== this.sentidoFiltro) return false;
                if (this.origemFiltro && i.origem !== this.origemFiltro) return false;
                if (!busca) return true;
                const texto = this.porUnidade
                    ? `${i.cod_unidade || ''} ${i.descricao_unidade || ''}`
                    : `${i.cod_linha || ''}`;
                return texto.toLowerCase().includes(busca);
            });
        },
        filtroIdLabel() {
            const ref = this.items.find((i) => Number(this.porUnidade ? i.id_unidade : i.id_linha) === this.filtroId);
            const nome = ref ? (this.porUnidade ? ref.descricao_unidade : ref.cod_linha) : `#${this.filtroId}`;
            return this.$t(
                this.porUnidade ? 'optimizedRoutesHistory.filteredUnit' : 'optimizedRoutesHistory.filteredLine',
                { nome },
            );
        },
        detailTitle() {
            const i = this.detailItem;
            if (!i) return '';
            const nome = this.porUnidade ? i.descricao_unidade : i.cod_linha;
            return `${this.$t('optimizedRoutesHistory.detailTitle')} — ${nome} · ${i.descricao_sentido}`;
        },
        selecionadaRow() {
            return this.versoes[this.indiceSelecionada] || null;
        },
        versaoAnteriorRow() {
            return this.versoes[this.indiceSelecionada + 1] || null;
        },
        resumoSelecionada() {
            const atual = this.metricas(this.selecionadaRow);
            const ant = this.metricas(this.versaoAnteriorRow);
            return atual.map((m, k) => {
                const base = ant[k];
                const deltaNum = m.num != null && base && base.num != null ? m.num - base.num : null;
                return {
                    ...m,
                    deltaNum,
                    delta: deltaNum != null && m.casas != null && deltaNum !== 0
                        ? `${deltaNum > 0 ? '+' : ''}${this.formatNumber(deltaNum, m.casas)}`
                        : null,
                };
            });
        },
        resumoAnterior() {
            return this.metricas(this.versaoAnteriorRow);
        },
        rotasSelecionada() {
            const v = this.versaoSelecionada;
            if (!v || !Array.isArray(v.rotas_json)) return [];
            return v.rotas_json.map((r, i) => ({
                key: i,
                cor: CORES_ROTAS[i % CORES_ROTAS.length],
                geojson: this.parseGeojson(r.geojson),
                paradas: Array.isArray(r.paradas) ? r.paradas : [],
                label: [
                    r.cod_turno,
                    r.distancia != null ? `${this.formatNumber(Number(r.distancia) / 1000, 1)} km` : null,
                    r.carga != null && r.capacidade != null ? `${r.carga}/${r.capacidade}` : null,
                ].filter(Boolean).join(' · ') || `#${i + 1}`,
            }));
        },
        geojsonsSelecionada() {
            if (this.porUnidade) {
                return this.rotasSelecionada.filter((r) => r.geojson).map((r) => ({ key: r.key, geojson: r.geojson, cor: r.cor }));
            }
            const g = this.versaoSelecionada && this.parseGeojson(this.versaoSelecionada.geojson);
            return g ? [{ key: 0, geojson: g, cor: COR_SELECIONADA }] : [];
        },
        geojsonsAnterior() {
            const v = this.versaoAnterior;
            if (!v) return [];
            if (this.porUnidade) {
                return (Array.isArray(v.rotas_json) ? v.rotas_json : [])
                    .map((r, i) => ({ key: i, geojson: this.parseGeojson(r.geojson) }))
                    .filter((r) => r.geojson);
            }
            const g = this.parseGeojson(v.geojson);
            return g ? [{ key: 0, geojson: g }] : [];
        },
        /** Mesmo efeito da aba Alterações: traço que anda no sentido do desenho e setas de sentido. */
        camadasSelecionada() {
            return this.geojsonsSelecionada.map((g) => this.camadaFluxo(
                g,
                g.cor,
                estiloFluxoSelecionada(g.cor),
                FLUXO_SELECIONADA,
                5,
            ));
        },
        camadasAnterior() {
            return this.geojsonsAnterior.map((g) => this.camadaFluxo(
                g,
                COR_ANTERIOR,
                estiloFluxoOriginal(COR_ANTERIOR),
                FLUXO_ORIGINAL,
                4,
            ));
        },
        paradasSelecionada() {
            const v = this.versaoSelecionada;
            if (!v) return [];
            const valida = (p) => toNumber(p.lat) != null && toNumber(p.lng) != null;
            if (this.porUnidade) {
                return this.rotasSelecionada.flatMap((r) => r.paradas.filter(valida).map((p, i) => ({
                    key: `${r.key}-${i}`,
                    lat: Number(p.lat),
                    lng: Number(p.lng),
                    cor: r.cor,
                    label: `${r.label} · ${this.$t('optimizedRoutesHistory.stop')} ${p.ordem != null ? p.ordem : i + 1}`,
                })));
            }
            const paradas = (Array.isArray(v.paradas_json) ? v.paradas_json : []).filter(valida).map((p, i) => ({
                key: `p-${i}`,
                lat: Number(p.lat),
                lng: Number(p.lng),
                cor: COR_SELECIONADA,
                label: `${this.$t('optimizedRoutesHistory.stop')} ${p.ordem_otimizada != null ? p.ordem_otimizada : i + 1}`,
            }));
            const naoAtendidas = (Array.isArray(v.nao_atendidas_json) ? v.nao_atendidas_json : []).filter(valida).map((p, i) => ({
                key: `n-${i}`,
                lat: Number(p.lat),
                lng: Number(p.lng),
                cor: COR_NAO_ATENDIDA,
                label: this.$t('optimizedRoutesHistory.notServed'),
            }));
            return [...paradas, ...naoAtendidas];
        },
        temGeometria() {
            return this.geojsonsSelecionada.length > 0 || this.geojsonsAnterior.length > 0 || this.paradasSelecionada.length > 0;
        },
    },
    watch: {
        mostraSelecionada() { this.ajustaMapa(); },
        mostraAnterior() { this.ajustaMapa(); },
    },
    created() {
        this.aplicaPeriodo(30);
        this.aplicaQuery();
    },
    mounted() {
        this.token = sessionStorage.getItem('api');
        this.populaRelatorio();
    },
    methods: {
        /** ?id=N&sentido=S: vindo do botão "Histórico" das abas Comparação (a aba vem de ?tipo, na tela). */
        aplicaQuery() {
            const q = this.$route ? this.$route.query : {};
            this.filtroId = toNumber(q.id);
            this.filtroSentido = toNumber(q.sentido);
            // Linha/unidade específica: os 90 dias que a rotina guarda de histórico
            if (this.filtroId != null) this.aplicaPeriodo(90);
        },
        /** Período padrão de `dias` dias operacionais (hora inicial do dia de operação das Configurações). */
        aplicaPeriodo(dias) {
            [this.dti, this.dtf] = DateUtils.periodoDiasOperacionais(
                this.$store.getters['config/horaInicialDiaOperacao'],
                dias,
            );
        },
        limpaFiltroId() {
            this.filtroId = null;
            this.filtroSentido = null;
            const q = this.$route ? this.$route.query || {} : {};
            if (q.id != null || q.sentido != null) {
                const query = q.tipo ? { tipo: q.tipo } : {};
                this.$router.replace({ query }).catch(() => {});
            }
            this.populaRelatorio();
        },
        toSqlDateTime(value) {
            const d = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(d.getTime())) return null;
            const pad = (n) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        endpoint() {
            return this.porUnidade
                ? apiController.endpoints.getHistoricorotasotimizadasunidade
                : apiController.endpoints.getHistoricorotasotimizadaslinha;
        },
        async populaRelatorio() {
            const dti = this.toSqlDateTime(this.dti);
            const dtf = this.toSqlDateTime(this.dtf);
            if (!dti || !dtf) return;
            const data = { acao: 'lista', dti, dtf, id_sentido: this.filtroSentido };
            data[this.porUnidade ? 'id_unidade' : 'id_linha'] = this.filtroId;
            this.loading = true;
            try {
                const res = await apiController.request(this.endpoint(), { data, silent: true });
                this.items = (Array.isArray(res.data) ? res.data : []).map((r) => this.normalizaLinha(r));
            } catch (e) {
                this.items = [];
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loading = false;
            }
        },
        normalizaLinha(r) {
            const distancia = toNumber(this.porUnidade ? r.distancia_total : r.distancia);
            const duracao = toNumber(this.porUnidade ? r.duracao_max : r.duracao);
            const origem = r.id_processo ? 'manual' : 'automatica';
            return {
                ...r,
                atual: Number(r.atual) === 1,
                chave: r.id_historico != null ? `h${r.id_historico}` : `a${r.id_linha || r.id_unidade}_${r.id_sentido}`,
                cod_linha: this.porUnidade ? undefined : [r.cod_linha, r.nome_linha].filter(Boolean).join(' - ') || `#${r.id_linha}`,
                descricao_unidade: this.porUnidade ? (r.descricao_unidade || `#${r.id_unidade}`) : undefined,
                descricao_sentido: Number(r.id_sentido) === -1
                    ? this.$t('optimizedRoutesHistory.bothDirections')
                    : (r.descricao_sentido || String(r.id_sentido)),
                distancia_km: distancia != null ? distancia / 1000 : null,
                duracao_min: duracao != null ? duracao / 60 : null,
                qtd_nao_atendidas: toNumber(r.qtd_nao_atendidas) || 0,
                origem,
                origem_extenso: this.$t(`optimizedRoutesHistory.origin.${origem === 'manual' ? 'manual' : 'automatic'}`),
                nome_usuario: r.nome_usuario || (r.id_processo ? '' : this.$t('optimizedRoutesHistory.routine')),
                dt_arquivamento_extenso: r.dt_arquivamento_extenso || this.$t('optimizedRoutesHistory.current'),
            };
        },
        chaveVersao(row) {
            return row.chave;
        },
        async openDetail(item) {
            this.detailItem = item;
            this.detailShow = true;
            this.detailLoading = true;
            this.versoes = [];
            this.versaoSelecionada = null;
            this.versaoAnterior = null;
            this.mostraSelecionada = true;
            this.mostraAnterior = true;
            this.mostraParadas = true;
            try {
                const data = { acao: 'versoes', id_sentido: item.id_sentido };
                data[this.porUnidade ? 'id_unidade' : 'id_linha'] = this.porUnidade ? item.id_unidade : item.id_linha;
                const res = await apiController.request(this.endpoint(), { data, silent: true });
                this.versoes = (Array.isArray(res.data) ? res.data : []).map((r) => this.normalizaLinha(r));
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.detailLoading = false;
            }
            const idx = this.versoes.findIndex((v) => v.chave === item.chave);
            this.mapKey += 1;
            this.selecionaVersao(idx >= 0 ? idx : 0);
        },
        async carregaVersao(row) {
            if (!row) return null;
            const data = { acao: 'versao', id_historico: row.id_historico, id_sentido: row.id_sentido };
            data[this.porUnidade ? 'id_unidade' : 'id_linha'] = this.porUnidade ? row.id_unidade : row.id_linha;
            const res = await apiController.request(this.endpoint(), { data, silent: true });
            return res.data || null;
        },
        async selecionaVersao(i) {
            if (!this.versoes[i]) return;
            this.indiceSelecionada = i;
            const seq = ++this.versaoSeq;
            this.versaoLoading = true;
            try {
                const [selecionada, anterior] = await Promise.all([
                    this.carregaVersao(this.versoes[i]),
                    this.carregaVersao(this.versoes[i + 1]),
                ]);
                if (seq !== this.versaoSeq) return;
                this.versaoSelecionada = selecionada;
                this.versaoAnterior = anterior;
                this.ajustaMapa();
            } catch (e) {
                if (seq === this.versaoSeq) EventBus.$emit('show-error', { error: e });
            } finally {
                if (seq === this.versaoSeq) this.versaoLoading = false;
            }
        },
        ajustaMapa() {
            this.$nextTick(() => {
                // O v-dialog anima a entrada: espera o mapa ter tamanho antes de enquadrar
                setTimeout(() => {
                    const comp = this.$refs.detailMap;
                    const map = comp && comp.mapObject;
                    if (!map) return;
                    map.invalidateSize();
                    const bounds = L.latLngBounds([]);
                    const geojsons = [
                        ...(this.mostraSelecionada ? this.geojsonsSelecionada : []),
                        ...(this.mostraAnterior ? this.geojsonsAnterior : []),
                    ];
                    geojsons.forEach((g) => {
                        try {
                            const b = L.geoJSON(g.geojson).getBounds();
                            if (b.isValid()) bounds.extend(b);
                        } catch (_) {
                            /* geojson inválido: ignora no enquadramento */
                        }
                    });
                    this.paradasSelecionada.forEach((p) => bounds.extend([p.lat, p.lng]));
                    if (bounds.isValid()) map.fitBounds(bounds, { padding: [20, 20] });
                }, 250);
            });
        },
        metricas(row) {
            if (!row) return [];
            const lista = [
                { label: this.$t('optimizedRoutesHistory.headers.status'), valor: this.statusLabel(row.status) },
                {
                    label: this.$t('optimizedRoutesHistory.headers.distancia_km'),
                    valor: this.formatNumber(row.distancia_km, 1),
                    num: row.distancia_km,
                    casas: 1,
                },
                {
                    label: this.$t('optimizedRoutesHistory.headers.duracao_min'),
                    valor: this.formatNumber(row.duracao_min, 0),
                    num: row.duracao_min,
                    casas: 0,
                },
                { label: this.$t('optimizedRoutesHistory.headers.qtd_paradas'), valor: row.qtd_paradas, num: toNumber(row.qtd_paradas), casas: 0 },
            ];
            if (this.porUnidade) {
                lista.push({ label: this.$t('optimizedRoutesHistory.headers.qtd_rotas'), valor: row.qtd_rotas, num: toNumber(row.qtd_rotas), casas: 0 });
            }
            lista.push(
                { label: this.$t('optimizedRoutesHistory.headers.qtd_nao_atendidas'), valor: row.qtd_nao_atendidas, num: row.qtd_nao_atendidas, casas: 0 },
                { label: this.$t('optimizedRoutesHistory.headers.dt_geracao_extenso'), valor: row.dt_geracao_extenso },
                {
                    label: this.$t('optimizedRoutesHistory.headers.origem_extenso'),
                    valor: [row.origem_extenso, row.nome_usuario].filter(Boolean).join(' · '),
                },
            );
            return lista;
        },
        resumoTimeline(row) {
            const partes = [`${this.formatNumber(row.distancia_km, 1)} km`, `${this.formatNumber(row.duracao_min, 0)} min`];
            if (this.porUnidade && row.qtd_rotas != null) partes.push(`${row.qtd_rotas} ${this.$t('optimizedRoutesHistory.routesShort')}`);
            return partes.join(' · ');
        },
        camadaFluxo(g, cor, estiloFluxo, classeFluxo, peso) {
            return {
                key: g.key,
                geojson: g.geojson,
                fundo: buildRouteLayerOptions(estiloFundoRota(cor, peso)),
                fluxo: buildRouteLayerOptions(estiloFluxo, classeFluxo),
                setas: buildDirectionMarkers(g.geojson).map((d) => ({ ...d, icon: iconDirecaoRota(d.bearing, cor) })),
            };
        },
        parseGeojson(gj) {
            if (!gj) return null;
            if (typeof gj === 'string') {
                try {
                    return JSON.parse(gj);
                } catch (e) {
                    return null;
                }
            }
            return typeof gj === 'object' ? gj : null;
        },
        origemLabel(row) {
            return row.origem_extenso;
        },
        statusLabel(status) {
            const key = `optimizedRoutesHistory.status.${status}`;
            return this.$te(key) ? this.$t(key) : status;
        },
        statusColor(status) {
            if (status === 'OK') return 'success';
            if (status === 'PARCIAL') return 'warning';
            if (status === 'ERRO') return 'error';
            return 'grey';
        },
        deltaClass(delta) {
            if (delta == null || delta === 0) return '';
            return delta < 0 ? 'success--text' : 'error--text';
        },
        formatNumber(v, casas) {
            const n = toNumber(v);
            if (n == null) return '—';
            return n.toLocaleString(this.$i18n ? this.$i18n.locale : 'pt-BR', {
                minimumFractionDigits: casas,
                maximumFractionDigits: casas,
            });
        },
    },
};
</script>

<style scoped>
.rho-map {
    height: 460px;
}

.rho-swatch {
    display: inline-block;
    width: 18px;
    height: 4px;
    border-radius: 2px;
    margin-right: 6px;
    vertical-align: middle;
}

.rho-swatch--dashed {
    height: 0;
    border-top: 3px dashed;
    border-radius: 0;
}

.rho-timeline {
    max-height: 560px;
    overflow-y: auto;
}

.rho-timeline-item {
    cursor: pointer;
    border-radius: 6px;
    padding: 6px 8px;
    margin: -6px -8px;
    transition: background-color 0.15s ease;
}

.rho-timeline-item:hover {
    background-color: rgba(21, 101, 192, 0.06);
}

.rho-timeline-item--active {
    background-color: rgba(21, 101, 192, 0.12);
    box-shadow: inset 3px 0 0 #1565C0;
}
</style>
